<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15BESnX/tc-custom/9781780106588.jpg?1718183002692" alt="This image is the cover for the book Plague of the Manitou"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Plague of the Manitou
      </h1>
      <p class="bookDescription body article font2">
        <b>A self-proclaimed psychic investigates a deadly plague that creates talking corpses in this chilling horror novel by the author of <i>Blind Panic</i>.</b><br/><br/>Virus expert Anna Grey is disturbed when a dying patient is wheeled past her lab vomiting fountains of blood and screaming like a banshee. To make matters worse, when she examines the man’s corpse, she could swear she hears him whisper: “Get it out of me.” John Patrick Bridges is dead. He’s definitely dead. But if he’s dead—how is he talking?<br/><br/>Anna wonders if she’s going mad. But then a second man hemorrhages and dies; yet Anna hears him whisper, “Please help me.”<br/><br/>There is no such thing as demons, Anna tells herself. But cynical fortune-teller Harry Erskine knows otherwise, and a series of extremely disturbing events are forcing him from his Miami home towards the bereaved Anna, who does not yet know the evil she is facing . . . <br/><br/><b>Praise for Graham Masterton</b><br/><br/>“God, he’s good.” —Stephen King<br/><br/>“One of the most original and frightening storytellers of our time.” —Peter James<br/><br/>“Suspenseful and tension-filled. . . . All the finesse of a master storyteller.” —<i>Guardian </i>(UK)<br/><br/>“One of Britain’s finest horror writers.” —<i>Daily Mail </i>(UK)<br/><br/>“You are in for a hell of a ride.” —<i>Grimdark Magazine</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Graham Masterton
      </h2>
      
      <p class="authorDescription body article">Graham Masterton was born in Edinburgh, Scotland, in 1946. He worked as a newspaper reporter before taking over joint editorship of the British editions of <I>Penthouse</I> and <I>Penthouse Forum </I>magazines. His debut novel, <I>The Manitou,</I> was published in 1976 and sold over one million copies in its first six months. It was adapted into the 1978 film starring Tony Curtis, Susan Strasberg, Stella Stevens, Michael Ansara, and Burgess Meredith. Since then, Masterton has written over seventy-five horror novels, thrillers, and historical sagas, as well as published four collections of short stories and edited <I>Scare Care</I>, an anthology of horror stories for the benefit of abused children. He and his wife, Wiescka, have three sons. They live in Cork, Ireland, where Masterton continues to write.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Severn House
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3bbaf3b0